const ExcelJS = require("exceljs");

async function generateExcel(workbook) {
  const excelFileName = `CIR Analyser - Group List ${new Date().toLocaleString().replace(",", " -")}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const blob = new Blob([buffer], { type: fileType });

  return { blob, excelFileName };
}

export async function exportGroups(data) {
  const workbook = new ExcelJS.Workbook();

  const sheet = workbook?.addWorksheet("WBS logs");
  const headerRow = sheet.addRow(["Group Name", "Supervisors"]);

  headerRow.eachCell((cell) => {
    cell.alignment = {
      wrapText: true,
      vertical: "middle",
      horizontal: "center",
    };
    cell.font = { bold: true };
  });

  sheet.autoFilter = {
    from: "A1",
    to: "A1",
  };

  data.forEach((group) => {
    const groupData = group?.data;
    const groupName = groupData?.group_name ?? group?.id;
    const supervisorEmails = groupData?.users
      ?.filter((user) => user.role === "Supervisor")
      .map((user) => user.email) || ["N/A"];

    sheet.addRow([groupName, ...supervisorEmails]);
  });

  sheet.columns = [{ width: 100 }, ...Array(8).fill({ width: 30 })];

  const { blob, excelFileName } = await generateExcel(workbook);
  return { blob, excelFileName };
}
